import { FC } from 'react';

import { useKeyboard } from '../../feature-player/hooks/skin/use-keyboard';

interface Props {
    isMovieActionsBlocked?: boolean;
    onClose?: () => void;
}

export const VodKeyboardController: FC<Props> = ({ isMovieActionsBlocked = false, onClose }) => {
    useKeyboard({ isMovieActionsBlocked, onClose });
    return null;
};
